import React, { useEffect, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Grid, Typography, Button } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import columns from './LogsTableColumns';
import ShowProgress from '../ui/Backdrop';
import { apiEndpoints } from '../../constants/apiEndpoints';

export const MonitorLogsTable = () => {
  const dispatch = useDispatch();

  const [logsData, setLogsData] = useState([]);

  const [logId, setLogId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [logIdData, setLogIdData] = useState({});

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    dispatch(showProgress(true));
    try {
      const response = await service.post(apiEndpoints.DEV_FETCH_LOGS);
      setLogsData(response);
    } catch (error) {
      console.error('Error fetching logs data', error);
    } finally {
      dispatch(showProgress(false));
    }
  };

  useEffect(() => {
    if (logId) {
      dispatch(showProgress(true));
      service
        .get(apiEndpoints.DEV_FETCH_LOG.replace('LOG_ID', logId))
        .then((response) => {
          dispatch(showProgress(false));
          setLogIdData(response || {});
        })
        .catch(() => {
          dispatch(showProgress(false));
          setLogIdData({});
        });
    }
  }, [logId, dispatch]);

  return (
    <Grid>
      <br />
      <Grid item>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography id="modal-modal-title" variant="h5" component="h2" alignItems="center">
            Error Logs
          </Typography>
          <Button onClick={getData}>
            <Refresh />
          </Button>
        </Grid>
      </Grid>
      <br />
      <Grid item>
        <MaterialReactTable
          columns={columns()}
          data={logsData}
          enableColumnActions
          enableColumnFilters
          enablePagination
          enableSorting
          enableBottomToolbar
          enableTopToolbar
          enableFullScreenToggle={false}
          muiTableBodyRowProps={{ hover: true }}
          enableStickyHeader
          enableDensityToggle={false}
          enableMultiRowSelection={false}
          muiTablePaginationProps={{
            rowsPerPageOptions: [50, 100, 150, 200, 250, 300],
          }}
          initialState={{ pagination: { pageSize: 100 } }}
          rowCount={logsData.length}
          positionActionsColumn="last"
          enableRowActions
          renderRowActions={({ row: { original } }) => (
            <RemoveRedEyeIcon
              onClick={() => {
                setLogId(original.id);
                setOpenModal(true);
              }}
              style={{ cursor: 'pointer' }}
            />
          )}
        />
      </Grid>

      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setLogIdData({});
          setLogId(null);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            width: '800px',
            height: '80vh',
            overflowY: 'auto',
            wordWrap: 'break-word',
            whiteSpace: 'initial',
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Log Info
          </Typography>
          <br />
          <span>
            <strong>Id:</strong> {logIdData.id}
          </span>
          <br />
          <span>
            <strong>Employee Hash:</strong> {logIdData.employeeHash}
          </span>
          <br />
          <span>
            <strong>Message:</strong> {logIdData.message}
          </span>
          <br />
          <span>
            <strong>Description:</strong> {logIdData.description}
          </span>
          <br />
          <span>
            <strong>Code:</strong> {logIdData.code || ''}
          </span>
          <br />
          <span>
            <strong>Level:</strong> {logIdData.level}
          </span>
          <br />
          <span>
            <strong>Transaction Id:</strong> {logIdData.transactionId}
          </span>
          <br />
          <span>
            <strong>Type:</strong> {logIdData.type}
          </span>
          <br />
          <span>
            <strong>Source:</strong> {logIdData.source}
          </span>
          <br />
          <span>
            <strong>Created At:</strong> {new Date(logIdData.updatedAt).toLocaleDateString()}
          </span>
          <br />
          <span>
            <strong>App Version:</strong> {logIdData.appVersion}
          </span>
          <br />
          <span>
            <strong>Stack Trace:</strong> {logIdData.stackTrace}
          </span>
          <br />
          <span>
            <strong>Context:</strong> {JSON.stringify(logIdData.context)}
          </span>
          <br />
        </Box>
      </Modal>
      <ShowProgress />
    </Grid>
  );
};

export default MonitorLogsTable;
